import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, 
    },
    resources: {
      en: {
        translation: {
          "nav.dashboard": "Dashboard",
          "nav.calendar": "Calendar",
          "nav.tasks": "Tasks",
          "nav.maintenance": "Maintenance",
          "nav.groceries": "Groceries",
          // Add your keys here
        }
      }
    }
  });

export default i18n;